import '../../../styles/login.css';
import doowiiMark from '../Root/assets/doowii-mark-full-color.png';

const DJ_URL = process.env.REACT_APP_DJ_URL || '';

function googleLoginHref() {
  // ``DJ_URL`` can be either an absolute URL (dev: "http://localhost:8000")
  // or a same-origin path prefix (prod: "/api" — we proxy /api/* to the
  // backend via nginx). ``new URL(path, base)`` throws when ``base`` is a
  // bare path, so build the string directly and let the browser resolve
  // relative URLs.
  const target = window.location.pathname + window.location.search;
  const apiBase = (DJ_URL || '').replace(/\/$/, '');
  const params = new URLSearchParams();
  if (target && target !== '/') params.set('target', target);
  const qs = params.toString();
  return `${apiBase}/google/login/${qs ? `?${qs}` : ''}`;
}

// Google brand guidelines: use the official 4-color G mark.
function GoogleMark() {
  return (
    <svg
      className="dossier-login-google-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      aria-hidden="true"
    >
      <path
        d="M17.64 9.2c0-.64-.06-1.25-.17-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92a8.78 8.78 0 0 0 2.68-6.61z"
        fill="#4285F4"
      />
      <path
        d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.83.86-3.04.86-2.34 0-4.32-1.58-5.03-3.7H.96v2.32A9 9 0 0 0 9 18z"
        fill="#34A853"
      />
      <path
        d="M3.97 10.72A5.41 5.41 0 0 1 3.68 9c0-.6.1-1.18.29-1.72V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3.01-2.32z"
        fill="#FBBC05"
      />
      <path
        d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.96L3.97 7.28C4.68 5.16 6.66 3.58 9 3.58z"
        fill="#EA4335"
      />
    </svg>
  );
}

export function LoginPage() {
  return (
    <main className="dossier-login">
      <section className="dossier-login-card">
        <img
          className="dossier-login-mark"
          src={doowiiMark}
          alt="Doowii"
        />
        <h1 className="dossier-login-title">Doowii Dossier</h1>
        <p className="dossier-login-tagline">
          Catalog, freshness, data quality, and usage signals —
          one view per tenant.
        </p>
        <a className="dossier-login-google" href={googleLoginHref()}>
          <GoogleMark />
          <span>Sign in with Google</span>
        </a>
        <p className="dossier-login-footer">
          Internal tool · restricted to @doowii.io accounts
        </p>
      </section>
    </main>
  );
}
